//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'
import moment from 'moment'

export default {
  props: {
    value: {
      default: ''
    }
  },
  data: function () {
    return {
      currentValue: ''
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val) {
          let r = moment(this.currentValue).format('YYYY-MM-DD')
          console.log('val', val)
          console.log('r', r)
          if (r !== val) {
            this.currentValue = moment(val).toDate()
          }
        }
      },
      immediate: true
    },
    currentValue: {
      handler (val) {
        if (val) {
          let r = moment(val).format('YYYY-MM-DD')
          if (this.value !== r) {
            this.$emit('input', r)
          }
        }
      }
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {

  }
}
